import Table from "../../../components/Table/Table";
import { Icon } from "@iconify/react";
import { TableSearch } from "../../../components/Table/TableActions";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import useWindowSize from "../../../hooks/useWindow";
import { Tooltip } from "@mui/material";

const GELL_ALL_SUBJECT_ENDPOINT = "/api/v1/teacher/subjects";

const AllSubject = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [subjectsData, setSubjectsData] = useState([]);

  const getAllSubjects = () => {
    httprequest.get(GELL_ALL_SUBJECT_ENDPOINT).then((res) => {
      setSubjectsData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const width = useWindowSize();
  const mobile = width < 600;

  useEffect(() => {
    // The data will be from the AllSubject get api endpint
    setSearchResult(getAllSubjects);
  }, []);

  const columns = [
    {
      name: "Subject",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    {
      name: "Class Name",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Class Name</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    {
      name: "Date Created",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date Created</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/subjects/subject-result/${row?.subject?.id}?class_id=${row?.class?.id}`}>
            <Tooltip title="View Subject Result" arrow placement="top">
              <button className="table-action-icon">
                <Icon icon="fluent:eye-16-regular" />
              </button>
            </Tooltip>
          </Link>
          <Link to="/lesson-notes">
            <Tooltip title="Lesson Notes" arrow placement="top">
              <button className="table-action-icon">
                <Icon icon="ri:newspaper-line" />
              </button>
            </Tooltip>
          </Link>
          <Link to={`/class-activities/employee/syllabus/${row?.subject?.id}?class_id=${row?.class?.id}`}>
            <Tooltip title="Syllabus" arrow placement="top">
              <button className="table-action-icon">
                <Icon icon="ph:book-open-text-light" />
              </button>
            </Tooltip>
          </Link>
        </div>
      )
    }
  ];
    // --| Filter All Subject table using name, email and class
  const handleSearchAllSubject = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = subjectsData?.filter((data) => valArray?.every(
      (word) => data?.class?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                data?.subject?.name
                                  ?.toLowerCase()
                                  .includes(word.toLowerCase()) ||
                                data?.label
                                  ?.toLowerCase()
                                  .includes(word.toLowerCase()) ||
                                  data?.type
                                    ?.toLowerCase()
                                    .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <>
      <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
        <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAllSubject} />}
      />
    </>
  );
};

export default AllSubject;
